module.exports = __webpack_public_path__ + "static/media/wrecker_salmon.235dbf49.svg";